import {useCallback, useState} from 'react';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import {initTransaction} from '../../../actions/zepzPayin/browser';

export const useZepzCardSelection = ({
    dispatch,
    csrfToken,
    platform,
    threeDSData
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = useCallback(async ({cardId, cvv}) => {
        try {
            setIsSubmitting(true);
            await initTransaction({
                platform,
                threeDSData,
                csrfToken,
                isNewCard: false,
                body: {
                    paymentSourceId: cardId,
                    cvv
                }
            });
        } catch (e) {
            dispatch(genericErrorHasOccurred(true));
        }
    }, []);

    return {
        isSubmitting,
        onSubmit
    };
};
